import React from 'react'
import {List, AutoSizer} from 'react-virtualized'
import Avatar from '../../../../Avatar/Avatar'
import styles from './RequestList.css'
import {serviceRequestStatusColor} from '../../../../../utils/helpers'
import {_L, useLocaleState} from '../../../../../context/LocaleContext'

const RequestList = ({requests}) => {
  const localeState = useLocaleState()

  const renderRow = ({index, key, style}) => {
    let row = requests[index]

    let description = row.description

    return (
      <div key={key} style={style}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '0 4px 0 4px',
            boxSizing: 'border-box'
          }}
        >
          <div style={{width: 50, height: 50, marginRight: 6}}>
            <Avatar url={row.imageUrl} large />
          </div>
          <div style={{flex: 1}}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                boxSizing: 'border-box',
                padding: '0 6px 0 6px'
              }}
            >
              <div className={styles.requestor}>{row.requestor_name}</div>
              <div
                style={{
                  marginLeft: 40,
                  fontSize: 14,
                  fontWeight: 700,
                  color: serviceRequestStatusColor[row.status]
                }}
              >
                {row.status}
              </div>
            </div>
            <div className={styles.description}>{description}</div>
          </div>
        </div>
      </div>
    )
  }

  let rowCount = requests.length

  return (
    <div className={styles.list}>
      {rowCount ? (
        <AutoSizer>
          {({width, height}) => {
            return (
              <List
                width={width}
                height={height}
                rowRenderer={renderRow}
                rowCount={rowCount}
                overscanRowCount={3}
                rowHeight={60}
              />
            )
          }}
        </AutoSizer>
      ) : (
        <div className={styles.noRecentText}>
          {_L({key: 'No Recent Requests', localeState})}
        </div>
      )}
    </div>
  )
}

export default RequestList

RequestList.defaultProps = {
  requests: []
}
